import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { TenantOverrideService } from '@core/services/tenant-override.service';

import { environment } from '@environments/environment';

/**
 * Attaches X-Admin-TenantId to every API request while an Admin is impersonating another
 * tenant (see TenantOverrideService). TenantAuthMiddleware re-verifies tenant membership
 * server-side on every request, so this header is a convenience, not a trust boundary.
 */
export const adminTenantOverrideInterceptor: HttpInterceptorFn = (req, next) => {
  const tenantId = inject(TenantOverrideService).activeTenantId();
  if (!tenantId || !req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { 'X-Admin-TenantId': tenantId } }));
};
